/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createIntegrationInstanceRequestSchema = z.object({
  credentialsId: z.int(),
  instanceId: z.string().min(1),
  instanceName: z.string().min(1),
  instanceUrl: z.string().min(1),
  sourceSystemType: z.enum(['JIRA', 'ADO']),
});
